<template>
	<div  class="droppable" v-bind="attrs">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "DroppableItem",
	props: {
		attrs: Object
	}
};
</script>
